import Forecast from "./Forecast";

export default Forecast

/**
 * import Forecast from "./Forecast"; 是一种常见的导入语句，它从名为"./Forecast"的模块中导入了一个默认导出的成员，并将其赋值给变量Forecast。
 * 这意味着在当前模块中，你可以使用Forecast这个变量来访问"./Forecast"模块的默认导出。
 * 
 * export {default} from "./Forecast"; 是一种常见的导出语句，它将名为"default"的默认导出成员从"./Forecast"模块中重新导出给其他模块使用。
 * 这意味着其他模块可以使用import语句来导入default变量，并访问"./Forecast"模块的默认导出。
 */